import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormHelperText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ClassifierModel from "../../core/api/ClassifierModel";

interface Props {
  value?: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  onBlur?: (event: React.FocusEvent<any>) => void;
  label?: string;
  className?: string;
  variant?: 'standard' | 'outlined' | 'filled';
  name?: string;
  id?: string;
  fullWidth?: boolean;
  labelId?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

function ManagersSelectInput({
  value,
  onChange,
  onBlur,
  label = 'Atsakingas asmuo',
  className,
  variant = 'outlined',
  name,
  id,
  fullWidth = true,
  labelId = 'user-responsible-label',
  error,
  helperText,
  disabled
}: Props): React.ReactElement {
  const [managers, setManagers] = useState<ClassifierModel[]>([]);
  
  useEffect(() => {
    ClassifierModel.usersClassifier().then((s) => {
      setManagers(s);
    });
  }, []);

  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        label={label}
        variant={variant}
        className={className}
        name={name}
        id={id}
        error={error}
        disabled={disabled}
      >
        <MenuItem value="">Nepasirinktas</MenuItem>
        {managers.map((manager) => (
          <MenuItem key={manager.id} value={manager.id}>
            {manager.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default ManagersSelectInput;
